/**
 * Wishlist, stored per browser.
 *
 * localStorage only for now: saving to the customer account needs the
 * write_customers scope and a metafield sync, which is a separate piece
 * of work. Everything here is keyed by product handle so that sync can
 * read the same list later without a migration.
 */
(function () {
  const KEY = 'hom:wishlist';

  const read = () => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      // Private mode, disabled storage, or corrupt JSON: fail quiet and
      // let the page work without a saved list.
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable; the toggle still reflects this page view */
    }
  };

  const paint = () => {
    const list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const on = list.includes(btn.dataset.wishlistHandle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();

    const handle = btn.dataset.wishlistHandle;
    if (!handle) return;

    const list = read();
    const i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);

    write(list);
    paint();
  });

  /**
   * Union the signed-in customer's saved list into local storage.
   *
   * Add-only by design: a customer signing in on a second device must
   * not lose what they saved there, and must not lose what the account
   * already held. Nothing is dropped on either side.
   */
  const mergeAccount = () => {
    const el = document.getElementById('WishlistAccountData');
    if (!el) return;
    let remote;
    try {
      remote = JSON.parse(el.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!Array.isArray(remote) || !remote.length) return;

    const local = read();
    const merged = [...new Set([...local, ...remote])];
    if (merged.length !== local.length) write(merged);
  };

  document.addEventListener('DOMContentLoaded', () => {
    mergeAccount();
    paint();
  });
  // Collection filtering swaps the grid without a page load, so repaint
  // whenever new cards arrive.
  document.addEventListener('shopify:section:load', paint);
  if (document.readyState !== 'loading') { mergeAccount(); paint(); }
})();
